export default `
  query getHrefLangs($path: String!) {
    getHrefLangs(page_path: $path) {
      link
      language
    }
  }
`;
